import { createTheme } from "@mui/material";

// Google fonts api
const fontUrl =
	"https://fonts.gstatic.com/s/sofiasans/v16/Yq6R-LCVXSLy9uPBwlATrOF6kjouQb4.woff2"; // sofia-sans latin font url, if fonts are messed, check this url and update if needed
const fontWeights = [100, 200, 300, 400, 500, 600, 700, 800, 900]; // font weights to load
const fontPromises = [];

fontWeights.forEach((weight) => {
	const font = new FontFace("Sofia Sans", `url(${fontUrl}) format('woff2')`, {
		weight: `${weight}`
	});
	fontPromises.push(font.load());
});

Promise.all(fontPromises)
	.then((loadedFonts) => {
		loadedFonts.forEach((loadedFont) => {
			document.fonts.add(loadedFont);
		});
		document.body.style.fontFamily = "'Sofia Sans', sans-serif";
	})
	.catch((error) => {
		console.log("Error loading fonts:", error);
	});

export const theme = createTheme({
	typography: {
		fontFamily: ["Sofia Sans"],
	}
});
